export const darkGrey    = '#828587'
export const lightGrey   = '#898c8d'
export const darkRed     = '#B61F30'
export const lightRed    = '#CF152A'
export const darkGreen   = '#10825D'
export const lightGreen  = '#15A677'
export const darkOrange  = '#994F00'
export const lightOrange = '#CC6900'
